import convertDataToContent from '@/utils/data/convertDataToContent';

interface RichTextBlockProps {
  data?: unknown;
  content?: unknown;
  modifiers?: string[];
}

const parseHtml = (content: string) => {
  return { __html: content };
};

const RichTextBlock = (props: RichTextBlockProps) => {
  const { data, content, modifiers } = props;

  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : '';

  const getHtml = () => {
    const source = data && !content ? convertDataToContent(data) : content;
    return parseHtml(
      source && typeof source === 'object'
        ? (source as { html: string }).html
        : (source as string),
    );
  };

  return (
    <div
      className={`RichTextBlock${modifierClasses}`}
      dangerouslySetInnerHTML={getHtml()}
    ></div>
  );
};

export default RichTextBlock;
